import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'
import '@/plugins/element.js'
import '@/plugins/vex-table.js'
import '@/permission' // permission control

// 懒加载
// const NormalLayout = () => import('@/layouts/Normal.vue')
// const PerferenceLayout = () => import('@/layouts/Perference.vue')
// const FNReportLayout = () => import('@/layouts/FNReport.vue')
// import NormalLayout from '@/layouts/Normal.vue'
// import PerferenceLayout from '@/layouts/Perference.vue'
// import FNReportLayout from '@/layouts/FNReport.vue'
import Breadcrumb from '@/components/Breadcrumb/index.vue'
import Narrow from '@/components/Narrow/index.vue'
import Panel from '@/components/Panel/index.vue'
import Thumbnail from '@/components/Thumbnail/index.vue'
import StateLabel from '@/components/StateLabel/index.vue'
import Flag from '@/components/Flag/index.vue'
import Drawer from '@/components/Drawer/index.vue'
import RawHtmlLimitNumber from '@/components/RawHtmlLimitNumber/index.vue'
import Attribute from '@/components/Attribute/index.vue'


import '@/styles/index.css'
import '@/styles/page.css'
import '@/icons'

import sticky from 'vue-sticky-header'
import VueI18n from 'vue-i18n'
import i18nMessages from './i18n'
import { installCardDragger } from 'carddragger'


import filters from '@/utils/filters'


Vue.use(sticky)
Vue.use(VueI18n)
Vue.use(installCardDragger)

// Vue.component('normal-layout', NormalLayout)
// Vue.component('perference-layout', PerferenceLayout)
// Vue.component('fn-report-layout', FNReportLayout)
Vue.component('breadcrumb', Breadcrumb)
Vue.component('narrow', Narrow)
Vue.component('panel', Panel)
Vue.component('thumbnail', Thumbnail)
Vue.component('state-label', StateLabel)
Vue.component('flag', Flag)
Vue.component('drawer', Drawer)
Vue.component('raw-html-limit-number', RawHtmlLimitNumber)
Vue.component('attribute', Attribute)



// console.log("=====main.js",)
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

// require('./mock');
Vue.config.productionTip = false
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue()


const i18n = new VueI18n({
  locale: 'cn', // set locale
  messages: i18nMessages // set locale messages
})

new Vue({
  router,
  // store,
  i18n,
  render: h => h(App),
}).$mount('#app')
